(function () {
  const DESKTOP_MIN_WIDTH = 1024;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches;
  }

  function openPopup(popup) {
    popup.hidden = false;
    popup.classList.add('is-open');
    document.documentElement.classList.add('tour-popup-open');
  }

  function closePopup(popup) {
    popup.hidden = true;
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('tour-popup-open');
  }

  function init() {
    const popup = document.querySelector('[data-tour-popup]');
    if (!popup) return;

    document.querySelectorAll('[data-tour-popup-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        if (!isDesktop()) return;
        event.preventDefault();
        openPopup(popup);
      });
    });

    popup.querySelectorAll('[data-tour-popup-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', function () {
        closePopup(popup);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(popup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
